export default __webpack_public_path__ + "static/media/fp_loading_screen.850224d6.png";